import { useEffect, useState } from "react";
import { searchFrontYards } from "../../../repository/RealEstateRepository";
import { LivingAreaCreate } from "../organism/";
import { DefaultPage } from "./";

const links = [
  {
    title: "Home",
    to: "/realestate"
  },
  {
    title: "LivingArea",
    to: "/realestate/livingarea"
  },
  {
    title: "Create",
  }
];

const LivingAreaCreatePage = (props) => {
  const [frontYards, setFrontYards] = useState(null);

  useEffect(() => {
    searchFrontYards({}, (data) => setFrontYards(data.content));
  }, []);

  return (<>
    <DefaultPage pathname={props.location.pathname} links={links}>
      {frontYards != null && (<>
        <LivingAreaCreate frontYards={frontYards} history={props.history} />
      </>)}
    </DefaultPage>
  </>);
};

export { LivingAreaCreatePage };
